import { Modal } from "components/common"
import DataTable from "components/common/dataTable/dataTable"
import { changeKeys } from "features/clients/clientsConstants"
import { t } from "i18next"

const columns = () => [
  {
    title: t("Field Name"),
    dataIndex: "fieldName",
    key: "fieldName",
    className: "tableStartSpace",
  },
  {
    title: t("Action"),
    dataIndex: "action",
    key: "action",
  },
  {
    title: t("From"),
    dataIndex: "from",
    key: "from",
  },
  {
    title: t("To"),
    dataIndex: "to",
    key: "to",
  },
]

export default function EditHistoryDetail({ formRef, editIndex, data }) {
  const getEditHistoryDetailData = (data, editIndex) => {
    if (data && data[editIndex]) {
      let editObject = data[editIndex]
      let changedFields = editObject?.changes ? Object.keys(editObject?.changes) : []

      return changedFields.map(changedField => {
        if (changedField == "ClientCellLogs") {
          let originalValue = editObject?.changes[changedField]?.cellsAdded,
            changedValue = editObject?.changes[changedField]?.cellsRemoved

          if (Array.isArray(originalValue)) {
            originalValue = originalValue.join(", ")
          }
          if (Array.isArray(changedValue)) {
            changedValue = changedValue.join(", ")
          }
          return {
            fieldName: changedField,
            action: editObject?.changes?.[changedField]?.action,
            from: originalValue || "-",
            to: changedValue || "-",
          }
        }

        return {
          fieldName: changedField,
          action: editObject?.changes?.[changedField]?.action,
          from: editObject?.changes?.[changedField]?.oldValue || "-",
          to: editObject?.changes?.[changedField]?.newValue || "-",
        }
      })
    }
  }

  return (
    <Modal
      title={t("Edit History Detail")}
      width={600}
      ref={formRef}
      onCancel={() => {
        formRef?.current?.setVisible(false)
      }}
    >
      <div>
        <DataTable data={getEditHistoryDetailData(data?.data, editIndex)} columns={columns()} stickyOffset={0} />
      </div>
    </Modal>
  )
}
